/**
 * Email API service for sending templated emails via Firebase Cloud Functions
 */

const getFunctionsUrl = () => {
    if (process.env.NODE_ENV === 'development' || import.meta.env.DEV) {
        return 'http://192.168.1.195:5001/';
    }

    return 'https://sendcouponemail-5iiwpornyq-uc.a.run.app';
};

export type SendCouponEmailParams = {
    email: string;
    couponId: string;
    offerName: string;
    rewardUrl: string;
    playerName?: string;
    language?: string;
    triggerName?: string;
};

export type EmailResponse = {
    success: boolean;
    message: string;
    error?: string;
};

export const EmailAPI = {
    /**
     * Send a coupon reward email to a player
     */
    async sendCouponEmail(params: SendCouponEmailParams): Promise<EmailResponse> {
        const url = getFunctionsUrl();

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(params),
            });

            // Check if response is JSON
            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                const text = await response.text();
                console.error('Non-JSON response:', text.substring(0, 200));
                return {
                    success: false,
                    message: `Erreur: Réponse invalide du serveur (${response.status})`,
                    error: `Expected JSON, got ${contentType}`,
                };
            }

            const result = await response.json();

            if (!response.ok) {
                return {
                    success: false,
                    message: result.message || "Erreur lors de l'envoi de l'email",
                    error: result.error,
                };
            }

            return result;
        } catch (error: any) {
            console.error('Error sending coupon email:', error);
            return {
                success: false,
                message: "Erreur de connexion lors de l'envoi de l'email",
                error: error.message,
            };
        }
    },
};
